import { render, staticRenderFns } from "./CardExpirationReportLocations.vue?vue&type=template&id=50fb773c&scoped=true&"
import script from "./CardExpirationReportLocations.vue?vue&type=script&lang=ts&"
export * from "./CardExpirationReportLocations.vue?vue&type=script&lang=ts&"
import style0 from "./CardExpirationReportLocations.vue?vue&type=style&index=0&id=50fb773c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fb773c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VDataTable,VLayout,VSelect,VSpacer,VToolbar,VToolbarTitle})
